import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import MyProfile from './pages/MyProfile';

// Pages
import LoginPage from './pages/auth/LoginPage';
import MainDashboard from './pages/dashboard/MainDashboard';
import DairyDashboard from './pages/dairy/DairyDashboard';
import ChemicalsDashboard from './pages/chemicals/ChemicalsDashboard';
import AgricultureDashboard from './pages/agriculture/AgricultureDashboard';
import AdhesiveDashboard from './pages/adhesive/AdhesiveDashboard';
import UsersManagement from './pages/UsersManagement';
import HRDashboard from './pages/hr/HRDashboard';

function App() {
  
  // Keep backend alive - ping every 4 minutes
  useEffect(() => {
    const keepAlive = setInterval(() => {
      fetch('https://sohaibenterprises.cloud/api/ping')
        .then(res => res.json())
        .then(data => console.log('✅ Backend alive:', data.timestamp))
        .catch(err => console.log('❌ Ping failed:', err));
    }, 4 * 60 * 1000); // 4 minutes

    return () => clearInterval(keepAlive);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes */}
          <Route
  path="/dashboard"
  element={
    <ProtectedRoute allowedRoles={['businessman']}>
      <MainDashboard />
    </ProtectedRoute>
  }
/>
          
          {/* Dairy Module */}
          <Route
            path="/dairy"
            element={
                            <ProtectedRoute module="dairy">
                <DairyDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* User Management */}
                    <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['businessman']}>
                <UsersManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          
          {/* Chemicals Module */}
          <Route
            path="/chemicals"
            element={
                            <ProtectedRoute module="chemicals">
                <ChemicalsDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Agriculture Module */}
          <Route
            path="/agriculture"
            element={
                            <ProtectedRoute module="agriculture">
                <AgricultureDashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Adhesive Tapes Module */}
          <Route
            path="/adhesive"
            element={
                            <ProtectedRoute module="adhesive">
                <AdhesiveDashboard />
              </ProtectedRoute>
            }
          />

          <Route
  path="/hr"
  element={
    <ProtectedRoute allowedRoles={['businessman']}>
      <HRDashboard />
    </ProtectedRoute>
  }
/>
          
          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;